export const getCellRendererProps = (properties) => {
  const {
    addRenderedRowListener,
    addRowCompListener,
    agGridReact,
    api,
    colDef,
    column,
    columnApi,
    context,
    data,
    eGridCell,
    eParentOfValue,
    formatValue,
    frameworkComponentWrapper,
    getValue,
    node,
    pinned,
    reactContainer,
    refreshCell,
    registerRowDragger,
    rowIndex,
    setValue,
    valueFormatted,
    ...rendererProps
  } = properties;

  return rendererProps;
};
